"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AudioCtx {
    constructor() {
        this._ctx = new AudioContext();
        this._output = this._ctx.createGain();
        this._output.connect(this._ctx.destination);
    }
    get ctx() {
        return this._ctx;
    }
    get now() {
        return this._ctx.currentTime;
    }
    get latency() {
        return this._ctx.baseLatency + this._ctx.outputLatency;
    }
    get mastervolume() {
        return this._output.gain;
    }
    get destination() {
        return this._output;
    }
}
window.AudioContext = window.AudioContext || window.webkitAudioContext;
const globalctx = AudioContext && new AudioCtx();
if (!globalctx) {
    throw new Error("Web Audio Api is not supported.");
}
exports.default = globalctx;
//# sourceMappingURL=GlobalCtx.js.map